/** Тони типів зв'язку (LINK_TYPES прототипу v4) для ребер і легенди навігатора. */
export const LINK_TONES: Record<string, string> = {
  relates: '#64748b', blocks: '#c2410c', blocked: '#b91c1c', parent: '#6b3fd1', child: '#7c3aed',
  duplicates: '#b7791f', duplicated: '#a16207', follows: '#1f8a5b', followed: '#15803d',
};

const PALETTE = ['#1f4ebc', '#c2410c', '#1f8a5b', '#6b3fd1', '#b7791f', '#0e7490', '#be123c', '#4d7c0f'];

/** Колір рамки вузла за модулем (сталий для модуля, з палітри прототипу). Чиста функція. */
export function moduleColor(module: string): string {
  let h = 0;
  for (let i = 0; i < module.length; i += 1) h = (h * 31 + module.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length]!;
}
